import React, { useState, useEffect } from 'react'
import '../css/style.css';
import '../css/login1.css';
import { NavLink } from 'react-router-dom';
import "react-custom-flag-select/lib/react-custom-flag-select.min.css";
import { useNavigate } from 'react-router-dom';
import {sub} from '../../services/user-api';
import {serviceId,Loader} from "../../utils/constant";

const Sub = () => {
    const [loading, setLoading] = useState(false);
    const [flowLoading, setFlowLoading] = useState(false);
    const navigate = useNavigate();
    const [otp, setOtp] = useState('');    
    const [phone, setPhone] = useState('');
    const [plan, setPlan] = useState(1);
    const [message, setMessage] = useState({message: "",error: false});

    const find = (arr, obj) => {
        return arr.filter(o => Object.keys(obj).every(i => obj[i] === o[i]));
      };
      
 
    const handleRadioChange = async(input) =>{
        setPlan(input);
      }      
    const handleButtonClick = async() => {
        //console.log(phone);
        setLoading(true);
        await sub({action:1,serviceId:serviceId,planId:plan,ani:phone,mode:'WAP'}).then((res) => {            
            console.log(res)
            localStorage.setItem("token", res.data.data.accessToken);
            window.location.href ="/success";
        }).catch((err) => {
            console.log(err)
            setMessage({message: err.message,error: true})
        }).finally(() => setLoading(false))
       // navigate('/profile');
      };

    useEffect(() => {    
        setFlowLoading(true);    
        const ani = localStorage.getItem('mmuvcann');
        //console.log("sub ani="+ani);
        if (ani==null || ani==undefined || ani.length<2) {
          navigate("/otp");
        }
        else 
        {
            setPhone(ani);
            sub({action:0,ani: ani,serviceId:serviceId}).then((res) => {
                console.log(res);                 
                if(res.data.data!==null && res.data.data!==undefined)
                {
                    localStorage.setItem("token", res.data.data.accessToken);
                    window.location.href ="/home";
                }
                else
                {
                    setFlowLoading(false);
                }
            }).catch((err) => {
                console.log(err);
                setFlowLoading(false);
            })
        }
    }, []);

    return (  
        flowLoading? <Loader />
        :<>     
        <div className='home'>
            <div className="maine-div">
                <div className="container-fluid box-wrapper login"> 
                    <div className='pt-5'>
                        <div className="login-thumbnail">
                            <img src="/images/uv_games_logo.png" alt="UVGames" />
                        </div>
                    </div>
                    <div className="login-header pb-4">
                        <div className="box-wrapper mx-auto text-center position-relative"> 
                            <span className="modal-level-title game-title">Welcome to UVGames</span>
                        </div>
                    </div>
                    <div className="login-info">
                        <div className="login-thumbnail2">
                            <img src="/images/login_img.png" alt="UVGames" />
                        </div>
                        <h3 className="login-title mb-3 mt-3 text-center">FIND NEW GAMES BASED ON NEW TECHNOLOGY WHICH ARE FULL WITH FUN, ENTERTAINMENT AND KNOWLEDGE.</h3>
                        <h3 className="header-title mb-3 mt-3 text-center">Select your subscription plan</h3>                        
                       
                        <div className="text-center radio">
                            <label>
                                <input type="radio" id="rd1" value="1" checked={plan === 1} onChange={() => handleRadioChange(1)} />
                                2Pula/Day
                            </label>
                            <label>
                                <input type="radio" id="rd2" value="2" checked={plan === 2} onChange={() => handleRadioChange(2)} />
                                7Pula/Week
                            </label>
                        </div>
                        <div className="text-center phone-info">
                        {
                            message.message && <div className="mb-3">
                            <p className={`alert alert-${message.error ? 'danger' : 'success'}`}>{message.message}</p>
                            </div>
                        }
                            {loading ? <Loader />:<button className="btn btn-primary btn-pm-custom" type="button" onClick={handleButtonClick}>Subscribe</button>}
                        </div>
                    </div>

                    
                </div>
            </div>
        </div>
        </>
    )
}

export default Sub